let i = 0;
export function uniqueId(prefix: string) {
    return `${prefix}-${++i}`;
}
